import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/role/obchodnik")({
  beforeLoad: requirePermissionGuard("hca.op.read"),
});
